import { Constants } from '@pwc/pwc-deals-web-common';
import { isCustomColourConversionActive } from 'common/helpers/projectInitUtil';
import { CUSTOM_COLOR_CONVERSION_KEY } from 'common/constants/General';
import CONSTANTS from '../../features/analyses/Freeform/FreeformAnalysisLayout/AddReportDataLayoutContainer/Constants';
import * as colourMaps from '../constants/PwcToJunctionStyles';
import sessionStorage from './sessionStorage';

export const clearSizingIfChartOnMobile = (element) => {
  const { matches } = window.matchMedia(
    `(max-width: ${CONSTANTS.VIEWPORT_WIDTHS.TABLET_LARGE}px)`
  );

  if (!matches) {
    return element;
  }
  const regex =
    /(<svg[^>]*class="excel-chart"[^>]*>)|(<svg[^>]*class="slides-canvas powerpoint-group"[^>]*>)/;
  return element.replace(regex, (match) => {
    const updatedMatch = match.replace(/\s*width="[^"]+"/, ' width="100%"');
    return updatedMatch.replace(/\s*height="[^"]+"/, '');
  });
};

const getProperTableColors = (darkMode) =>
  darkMode
    ? colourMaps.pwcToJunctionTableDarkModeColours
    : colourMaps.pwcToJunctionTableColours;
export const junctionColorMapping = (
  html,
  darkMode = false,
  libraryItem = undefined,
  isLiveReportPreview = false
) => {
  let mapped = html;
  const contentColourConversion = sessionStorage.get(
    CUSTOM_COLOR_CONVERSION_KEY
  );
  const isCustomColourConversion = isCustomColourConversionActive(
    contentColourConversion
  );
  const mapColorsFn = (colourMap, htmlStr) => {
    if (!isCustomColourConversion) {
      Object.keys(colourMap).forEach((sourceKey) => {
        const regex = new RegExp(`${sourceKey}`, 'mig');
        if (isLiveReportPreview) {
          htmlStr = htmlStr.replace(regex, () => sourceKey);
        } else {
          htmlStr = htmlStr.replace(regex, colourMap[sourceKey]);
        }
      });
    }
    return htmlStr;
  };
  if (
    !(
      libraryItem?.type ===
        Constants.LIBRARY_ITEM_TYPES.POWER_POINT_GROUP.value ||
      libraryItem?.type === Constants.TOPIC_PANEL_TYPES.POWER_POINT_GROUP.value
    )
  ) {
    const xmlDoc = new DOMParser().parseFromString(html, 'text/html');
    const svgs = xmlDoc.getElementsByTagName('svg');
    // Replace SVG charts only
    if (svgs) {
      Array.from(svgs)
        .filter(
          (item) =>
            !item.classList.contains('powerpoint-group') &&
            !item.classList.contains('excel-table')
        )
        .forEach((x) => {
          x.innerHTML = mapColorsFn(
            colourMaps.pwcToJunctionChartColours,
            x.innerHTML
          );
        });
    }

    // only for tables
    const tableStyles = xmlDoc.getElementsByTagName('style');

    if (tableStyles) {
      const colourMapTable = getProperTableColors(darkMode);
      Array.from(tableStyles).forEach((x) => {
        x.innerHTML = mapColorsFn(colourMapTable, x.innerHTML);
      });
    }

    const htmlStr =
      xmlDoc.children && xmlDoc.children.length > 0
        ? xmlDoc.children[0].innerHTML
        : '';
    mapped = htmlStr;
  }

  // Some hacks to get round Aspose's embedded MS derived styles
  const borderRightStringPattern = 'border-right:1px solid #000000';
  const borderRightRegex = new RegExp(`${borderRightStringPattern}`, 'mig');
  const borderRightReplacementString =
    'border-right:1px solid var(--table-border-color)';

  if (mapped) {
    // it makes charts responsive
    mapped = clearSizingIfChartOnMobile(mapped);
    mapped = mapped.replace(borderRightRegex, borderRightReplacementString);

    const whiteBgStringPattern = 'background:#FFFFFF';
    const whiteBgRegex = new RegExp(`${whiteBgStringPattern}`, 'mig');
    mapped = mapped.replace(whiteBgRegex, '');
    mapped = mapped.replace(
      '<div><svg style="max-width:100%;max-height:100%;" ',
      '<svg'
    );

    mapped = mapped.replace(
      '<svg',
      '<div><svg style="max-width:100%;max-height:100%;" '
    );

    mapped = mapped.replace('</svg></div>', '</svg>');
    mapped = mapped.replace('</svg>', '</svg></div>');
  }

  return mapped;
};

export const junctionSmartSymbolsMapping = (html) => {
  try {
    const dom = new DOMParser().parseFromString(html, 'text/html');
    const styleTag = dom.querySelector('style');

    if (!styleTag?.sheet?.cssRules) return html;

    const smartSymbolsClassNames = Array.from(styleTag.sheet?.cssRules)
      .filter((block) => {
        return /smart symbols/i.test(block.style.fontFamily);
      })
      .map((block) => block.selectorText.match(/pwc-excel-[a-z0-9-]+/)?.[0])
      .filter((block) => !!block);

    Array.from(dom.querySelectorAll('td'))
      .filter((cell) =>
        smartSymbolsClassNames.some((c) => cell.className.includes(c))
      )
      .forEach((cell) => {
        cell.style.fontFamily = "'Smart Symbols', sans-serif";
      });

    return dom.documentElement.outerHTML;
  } catch (e) {
    return html;
  }
};
